module.exports = __webpack_public_path__ + "static/media/highlight-right-mobile.98293501.svg";